import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

/*export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}*/
// 添加一个全局变量来缓存token，避免频繁读取Pinia
let cachedToken = ''

export function setTokenCache(token) {
    cachedToken = token
}

export function getToken() {
    // 优先返回缓存的token（来自Pinia）
    if (cachedToken) {
        return cachedToken
    }
    // 其次从Cookies读取
    return Cookies.get(TokenKey)
}

export function setToken(token) {
    cachedToken = token // 更新缓存
    return Cookies.set(TokenKey, token)
}

export function removeToken() {
    cachedToken = '' // 清除缓存
    return Cookies.remove(TokenKey)
}
